/**
 * @copyright (C) 2024, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Charyung Kim (crkim@rsupport.com)
 *
 * @description
 *
 * @created at Mon Dec 30 2024
 **/

import { forwardRef, CSSProperties, HTMLAttributes } from "react";

import { IndicatorWrapperStyle, IndicatorStyle, IconStyle, UsernameWrapperStyle, UsernameStyle } from "./emotion";
import Icons from "@/assets/icons/indicator";

type IndicatorProps = {
	styles?: CSSProperties;
	name: string;
	color: string;
	icon: string;
	isPlayer: boolean;
} & HTMLAttributes<HTMLDivElement>;

const Indicator = forwardRef<HTMLDivElement, IndicatorProps>(
	({ styles, icon, color, name, isPlayer, ...rest }, ref) => {
		return (
			<div css={IndicatorWrapperStyle} className={icon === "marker" ? "offsetTop" : ""}>
				<div className="indicators" css={IndicatorStyle} style={styles} ref={ref} {...rest}>
					{/* Icon */}
					<div css={IconStyle}>{Icons[icon]({ color })}</div>
					{/* Username */}
					<div css={UsernameWrapperStyle}>
						<div css={UsernameStyle(color)} className={isPlayer ? "active" : ""}>
							{name}
						</div>
					</div>
				</div>
			</div>
		);
	}
);

export default Indicator;
